import { useState } from 'react';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui';
import { useUIStore } from '@/stores/uiStore';
import { useCommand } from '@/features/ai/useCommand';
import { AskThread } from '@/features/ai/AskThread';
import { AskComposer } from '@/features/ai/AskComposer';
import { dispatch as dispatchAction } from '@/features/ai/actionDispatcher';

export function CommandPalette() {
  const open = useUIStore((s) => s.commandPaletteOpen);
  const setOpen = useUIStore((s) => s.setCommandPaletteOpen);
  const {
    messages,
    streamingText,
    loading,
    error,
    run,
    newChat,
    outcomes,
    markOutcome,
    clearOutcome,
  } = useCommand();
  const [input, setInput] = useState('');

  const submit = () => {
    const text = input.trim();
    if (!text || loading) return;
    void run(text);
    setInput('');
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="w-[min(92vw,560px)]">
        <DialogTitle className="sr-only">Ask Brainday</DialogTitle>

        {messages.length > 0 ? (
          <div className="mb-2 flex justify-end">
            <button
              type="button"
              onClick={() => {
                newChat();
                setInput('');
              }}
              className="rounded text-caption text-t3 can-hover:hover:text-t1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-canvas"
            >
              New chat
            </button>
          </div>
        ) : null}

        <div className="mb-3 max-h-[52vh] overflow-y-auto">
          <AskThread
            messages={messages}
            streamingText={streamingText}
            loading={loading}
            error={error}
            initialOutcomes={outcomes}
            onMarkOutcome={markOutcome}
            onClearOutcome={clearOutcome}
            onAction={(a) => dispatchAction(a, { silent: true })}
            onSuggestion={(t) => {
              setInput('');
              void run(t);
            }}
          />
        </div>

        <AskComposer
          value={input}
          onChange={setInput}
          onSubmit={submit}
          placeholder={messages.length ? 'Ask a follow-up…' : 'Ask Brainday…'}
          disabled={loading}
          autoFocus
        />
      </DialogContent>
    </Dialog>
  );
}
